<template>
  <div
    class="pt-2 pt-md-3"
    :class="{ 'col-8 offset-3': !isMobile }">
    <div v-if="isMobile">
      <action-header page-header>
        <h5>Gift Cards</h5>
      </action-header>
    </div>
    <div
      v-else
      class="container pt-4 px-0">
      <bread-crumb
        class="mb-3"
        current-location="Gift Cards"
        :crumbs="[{ name: 'Account', to: { name: 'account' } }]"/>
      <h2 class="pb-3 mx-2 mx-md-3 text-md-start">
        Gift Cards
      </h2>
    </div>
    <div class="container">
      <div class="row">
        <base-alert
          v-if="showAlert"
          key="alert"/>
        <div class="col">
          <h3>Balance: {{ formatPrice(balance) }}</h3>
          Add a new gift card to your balance
          <GiftCardPromoCodeInput
            v-model="code"
            location="Gift Cards Page"
            label="Enter Gift Code"
            style="max-width: 600px;"
            :disabled="applyDisabled"
            :errors="gcErrors"
            @apply="apply"/>
        </div>
      </div>
      <div class="d-flex mt-4">
        <base-checkbox
          v-model="applyGiftCardsToSubscriptions"
          class="mb-3"
          text="Apply gift card balance to my subscription"
          @input="setApplyToSubscription($event)"/>
      </div>
      <div class="col pt-5">
        <h3>Transaction Summary</h3>
      </div>
      <div class="transactions">
        <div
          v-for="(transaction, index) in giftCardTransactions"
          :key="index">
          <gift-card-transaction :transaction/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ActionHeader from '../../global/sequin/ActionHeader'
import BreadCrumb from '../../global/sequin/BreadCrumb'
import GiftCardTransaction from './GiftCardTransaction'
import { storeToRefs } from 'pinia'
import { formatPrice } from '@/utils/stringParsing.js'
import BaseAlert from '@/components/global/BaseAlert.vue'
import GiftCardPromoCodeInput from '@/components/global/GiftCardPromoCodeInput.vue'
import BaseCheckbox from '@/components/global/BaseCheckbox.vue'
import { computed, onMounted, ref } from 'vue'
import { useAccountStore } from '@/stores/account.js'
import { useClientStore } from '@shared/stores/client.js'
import { useGlobalStore } from '@/stores/global.js'

defineOptions({
  compatConfig: {
    COMPONENT_V_MODEL: false
  }
})

const gcErrors = ref([])
const code = ref('')
const applyDisabled = ref(false)

const accountStore = useAccountStore()
const { getGiftCardTransactions, updateApplyGiftCardsToSubscriptionChoice, activateGiftCard } = accountStore
const { giftCardTransactions } = storeToRefs(accountStore)

const { applyGiftCardsToSubscriptions } = storeToRefs(useClientStore())

const globalStore = useGlobalStore()
const { setAlert } = globalStore
const { showAlert } = storeToRefs(globalStore)

const balance = computed(() => {
  if (giftCardTransactions.value && giftCardTransactions.value.length > 0) {
    return giftCardTransactions.value[0].clientClosingBalance
  }
  return 0
})

onMounted(() => {
  getGiftCardTransactions()
})

async function setApplyToSubscription (event) {
  try {
    updateApplyGiftCardsToSubscriptionChoice(event)
  } catch (errors) { /* empty */ }
}

async function apply () {
  applyDisabled.value = true
  gcErrors.value = []
  try {
    await activateGiftCard(code.value)
    setAlert({ msg: 'Your gift card has been applied.' })
    gcErrors.value = []
    code.value = ''
  } catch (errors) {
    gcErrors.value = Array.isArray(errors) ? errors : [errors]
  }
  applyDisabled.value = false
}
</script>

<style scoped>
.transactions {
  max-width: 750px;
}
</style>
